import React, { useEffect, useRef, useState } from "react";

import { useSelector } from "react-redux";
import StarRoundedIcon from "@mui/icons-material/StarRounded";
import "react-lazy-load-image-component/src/effects/blur.css";

function MobileImgSlider({ selectProduct }) {
  const selectedVariant = useSelector(
    (state) => state.productDetail.selectedVariant
  );

  const [sliderState, setSliderState] = useState({
    slideIndex: 1,
    images: [],
    width: 0,
    start: 0,
    change: 9,
    hovering: false,
    bigImage: "",
  });

  const [touchStart, setTouchStart] = useState(0);
  const [touchEnd, setTouchEnd] = useState(0);
  const slideRef = useRef();

  useEffect(() => {
    if (selectProduct && selectProduct.length > 0) {
      const selectedImages = selectProduct[0]?.SKU_Images?.find(
        (p) => p?.SKU_ID === selectedVariant?.SKU_ID
      );
      let imagesArray = [];
      if (selectedImages) {
        imagesArray = selectedImages?.images.map(
          (url) =>
            `https://cyclecircle.blr1.cdn.digitaloceanspaces.com/${process.env.REACT_APP_IMAGE_BASE}_PRODUCTS_IMAGE/${url}`
        );
      } else if (selectProduct[0]?.images) {
        imagesArray = selectProduct[0]?.images[0]?.map(
          (url) =>
            `https://cyclecircle.blr1.cdn.digitaloceanspaces.com/${process.env.REACT_APP_IMAGE_BASE}_PRODUCTS_IMAGE/${url}`
        );
      }
      setSliderState((prev) => ({
        ...prev,
        images: imagesArray,
        bigImage: imagesArray[0],
        slideIndex: 1,
      }));
    }
  }, [selectProduct, selectedVariant]);

  useEffect(() => {
    if (!slideRef.current) return;
    const scrollWidth = slideRef.current.scrollWidth;
    const count = slideRef.current.childElementCount;
    setSliderState((prev) => ({ ...prev, width: scrollWidth / count }));
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      if (!sliderState.hovering) plusSlides(1);
    }, 5000);
    return () => clearInterval(interval);
  }, [sliderState.hovering, sliderState.slideIndex]);

  const plusSlides = (n) => {
    if (sliderState.images.length === 0) return;
    const newIndex =
      ((sliderState.slideIndex - 1 + n + sliderState.images.length) %
        sliderState.images.length) +
      1;
    setSliderState((prev) => ({
      ...prev,
      slideIndex: newIndex,
      bigImage: sliderState.images[newIndex - 1],
    }));
  };

  const handleTouchStart = (e) => setTouchStart(e.targetTouches[0].clientX);
  const handleTouchMove = (e) => setTouchEnd(e.targetTouches[0].clientX);
  const handleTouchEnd = () => {
    if (touchStart - touchEnd > 150) plusSlides(1);
    else if (touchStart - touchEnd < -150) plusSlides(-1);
  };

  return (
    <div className="w-full overflow-hidden relative bg-white">
      {/* ⭐ Rating Tag */}
      <div className="absolute top-3 right-3 flex items-center gap-1 bg-green text-white px-2 py-[2px] rounded-sm z-10">
        <span className="text-sm font-semibold">
          {parseInt(selectProduct?.[0]?.net_rating).toFixed(1)}
        </span>
        <StarRoundedIcon sx={{ fontSize: "16px" }} />
      </div>

      {/* 🖼️ Main Image */}
      <div className="w-full h-[35vh] border-y border-gray-200 flex items-center justify-center">
        <div
          className="w-[80%] h-full flex justify-center items-center"
          onTouchStart={handleTouchStart}
          onTouchMove={handleTouchMove}
          onTouchEnd={handleTouchEnd}
          onMouseEnter={() =>
            setSliderState((prev) => ({ ...prev, hovering: true }))
          }
          onMouseLeave={() =>
            setSliderState((prev) => ({ ...prev, hovering: false }))
          }
        >
          <img
            loading="lazy"
            src={sliderState.bigImage}
            alt=""
            className="w-full h-full object-contain"
          />
        </div>
      </div>

      {/* 🔄 Thumbnail Row */}
      <div
        ref={slideRef}
        className="flex gap-3 overflow-x-auto no-scrollbar px-4 py-2 mt-2 select-none"
      >
        {sliderState.images.map((image, index) => (
          <div
            key={index}
            className={`min-w-[25vw] max-w-[25vw] h-[20vw] flex items-center justify-center border rounded-md transition-all duration-300 ${
              index + 1 === sliderState.slideIndex
                ? "border-blue opacity-100"
                : "border-gray-300 opacity-50"
            }`}
            onClick={() =>
              setSliderState((prev) => ({
                ...prev,
                slideIndex: index + 1,
                bigImage: image,
              }))
            }
          >
            <img
              src={image}
              alt=""
              loading="lazy"
              className="w-full h-full object-cover rounded-md"
            />
          </div>
        ))}
      </div>
    </div>
  );
}

export default MobileImgSlider;
